import {
	FETCH_EVENT_POINT,
	DELETE_EVENT_POINT,
	UPDATE_EVENT_POINT,
	CREATE_EVENT_POINT,
	FETCH_ATTENDEE_POINT,
	CREATE_ATTENDEE_POINT,
	UPDATE_ATTENDEE_POINT,
	DELETE_ATTENDEE_POINT,
} from '../actions/actionTypes';

const preState = { eventPoint: null, attendeePoints: {} };

const pointsReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, eventPoint, attendeePointsByID, attendeePoint } = action;
	const attendeeID = attendeePoint && attendeePoint.attendee_id;
	const attendeePoints = stateDup.attendeePoints[attendeeID] || [];

	switch (type) {
		case FETCH_EVENT_POINT:
			return { ...stateDup, eventPoint };
		case DELETE_EVENT_POINT:
			return { ...stateDup, eventPoint: {} };
		case UPDATE_EVENT_POINT:
			return { ...stateDup, eventPoint };
		case CREATE_EVENT_POINT:
			return { ...stateDup, eventPoint };
		case CREATE_ATTENDEE_POINT:
			if (attendeePoints.some(p => p.id === attendeePoint.id)) return stateDup;
			return {
				...stateDup,
				attendeePoints: {
					...stateDup.attendeePoints,
					[attendeeID]: [...attendeePoints, attendeePoint],
				},
			};
		case UPDATE_ATTENDEE_POINT:
			const index = attendeePoints.findIndex(point => point && point.id === attendeePoint.id);
			if (index === -1 || !attendeePoint) return stateDup;
			const updatedPointsArray = [
				...attendeePoints.slice(0, index),
				attendeePoint,
				...attendeePoints.slice(index + 1),
			];
			return {
				...stateDup,
				attendeePoints: { ...stateDup.attendeePoints, [attendeeID]: updatedPointsArray },
			};
		case DELETE_ATTENDEE_POINT:
			const filteredAttendeePoints = attendeePoints.filter(
				point => point && point.id !== attendeePoint.id
			);
			return {
				...stateDup,
				attendeePoints: { ...stateDup.attendeePoints, [attendeeID]: filteredAttendeePoints },
			};
		case FETCH_ATTENDEE_POINT:
			return { ...stateDup, attendeePoints: { ...stateDup.attendeePoints, ...attendeePointsByID } };
		default:
			return stateDup;
	}
};

export default pointsReducer;
